module.exports = __webpack_public_path__ + "static/media/Enterprise.19be5b11.png";